export enum LOCALE {
  en = 'en',
  de = 'de'
}

export const locales = {
  [LOCALE.en]: {
    label: 'English',
    flag: '🇬🇧'
  },
  [LOCALE.de]: {
    label: 'Deutsch',
    flag: '🇩🇪'
  }
}

export const defaultLocale = LOCALE.en
